import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';
import { VersionState } from '../states/version.state';

export const selectVersionFeature = (state: AppState) => state.version;

export const setVersions = createSelector(
    selectVersionFeature,
    (state: VersionState) => state.versions
  );

export const setSelectedVersion = createSelector(
    selectVersionFeature,
    (state: VersionState) => state.selectedVersion
  );

export const setListStatus = createSelector(
    selectVersionFeature,
    (state: VersionState) => state.listStatus
);

export const setGetStatus = createSelector(
  selectVersionFeature,
  (state: VersionState) => state.getStatus
);

export const setUpdateStatus = createSelector(
  selectVersionFeature,
  (state: VersionState) => state.updateStatus
);

export const setCreateStatus = createSelector(
  selectVersionFeature,
(state: VersionState) => state.createStatus
);

export const setDeleteStatus = createSelector(
  selectVersionFeature,
(state: VersionState) => state.deleteStatus
);

/* export const selectVersion = createSelector(
    selectVersionFeature, (state: VersionState) => state
) */